import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var SunSvg = function SunSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.273 4.727V2h1.454v2.727zM6.486 7.514 4.668 5.696l1.028-1.028 1.818 1.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.808 6.709a5.727 5.727 0 1 1 4.384 10.582A5.727 5.727 0 0 1 9.808 6.71M12 7.727a4.273 4.273 0 1 0 0 8.546 4.273 4.273 0 0 0 0-8.546",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.514 7.514 1.819-1.818-1.029-1.028-1.818 1.818zM17.514 16.486l1.819 1.818-1.029 1.029-1.818-1.819zM6.486 16.486l-1.818 1.818 1.028 1.029 1.818-1.819zM11.273 19.273V22h1.454v-2.727zM4.727 12.727H2v-1.454h2.727zM19.273 12.727H22v-1.454h-2.727z"
  }));
};
export var Sun = function Sun(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: SunSvg
  }));
};